/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize RiskRegister View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RiskRegisterView';

export const mapStateToPropsRiskRegister = mapStateToProps;
export const mapDispatchToPropsRiskRegister = mapDispatchToProps;

export default connect(
  mapStateToPropsRiskRegister,
  mapDispatchToPropsRiskRegister
)(View);
